import React, { useEffect, useCallback, useState } from "react";
import { withRouter } from "react-router-dom";
import { Grid } from "@material-ui/core";
import clsx from "clsx";
import Modal from "react-modal";
import styles from "./styles.module.css";
import { useModalStyles } from "../../Util/CSS/ModalStyles";
import LoadingScreen from "../../Shared/LoadingScreen";
import OpenSnackbar from "../../Shared/OpenSnackbar";
import NewReqAvatar from "./NewReqAvatar";
import { NewReqEditStyle } from "../../Util/CSS/NewReqEdit/NewReqEdit";
import EditForm from "./EditForm";
import axios from "axios";

// { match }
const NewReqEdit = ({
  id,
  open,
  handleClose,
  whichModal,
  minHeight,
  top,
  topMobile,
  height,
  width,
}) => {
  const modalClasses = useModalStyles(top, topMobile, height, width, minHeight);
  const initialState = {
    ownerName: "",
    request_time: "",
    restName: "",
    contactNumber: "",
    email: "",
    lead_status: "",
    Rest_logo: "",
    Rest_logo_alt: "",
    state: "",
    city: "",
    id: 8,
  };
  const classes = NewReqEditStyle();
  // const { params } = match;
  // const { id } = params;
  const [RestData, setRestData] = useState(initialState);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [snackbarDetails, setSnackbarDetails] = useState({
    message: "",
    type: "",
  });
  const getReqInfo = useCallback(async () => {
    setLoading(true);
    try {
      let res = await axios.get(
        `${process.env.REACT_APP_API_URL}restaurantReq/${id}`
      );
      if (res) {
        setRestData(res.data.Item);
        setLoading(false);
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        handleSnackbarOpen(error.response.data.error, "errorDark");
      } else if (error.message) {
        handleSnackbarOpen(error.message, "errorDark");
      } else {
        handleSnackbarOpen("Something went wrong!", "errorDark");
      }
      setLoading(false);
    }
  }, []);
  const handleSnackbarOpen = (message, type) => {
    let obj = {
      message,
      type,
    };
    setSnackbarDetails(obj);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    getReqInfo();
  }, [getReqInfo]);
  return (
    <>
      {Loading ? (
        <LoadingScreen loading={Loading} />
      ) : (
        <>
          <Modal
            isOpen={open}
            ariaHideApp={false}
            onRequestClose={handleClose}
            contentLabel="My dialog"
            className={styles.mymodal}
            overlayClassName={styles.myoverlay}
            closeTimeoutMS={50}
          >
            <div className={`${classes.paper} `}>
              <Grid container className={clsx(classes.dFlow)}>
                <Grid item xs={12} className={classes.mb20}>
                  <NewReqAvatar
                    classes={classes}
                    RestData={RestData}
                    setRestData={setRestData}
                  />
                </Grid>
                <Grid item xs={12}>
                  <EditForm
                    classes={classes}
                    RestData={RestData}
                    setRestData={setRestData}
                  />
                </Grid>
                <Grid item xs={12} className={clsx(classes.alignRight)}></Grid>
              </Grid>
            </div>
          </Modal>
        </>
      )}
      {snackbarOpen && (
        <OpenSnackbar
          open={snackbarOpen}
          message={snackbarDetails.message}
          type={snackbarDetails.type}
          setOpen={setSnackbarOpen}
          vertical="bottom"
          horizontal="center"
        />
      )}
    </>
  );
};

export default withRouter(NewReqEdit);
